"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.normalize = void 0;

var convert_1 = require("@shootismoke/convert");

var date_fns_tz_1 = require("date-fns-tz");

var E = __importStar(require("fp-ts/lib/Either"));

var pipeable_1 = require("fp-ts/lib/pipeable");

var util_1 = require("../../util");

var sanitized_json_1 = __importDefault(require("./sanitized.json"));
/**
 * Sanitize the country we get here from aqicn. For example, for China, the
 * string after 'https://aqicn.org/city/' is not 'china', but directly the
 * Chinese privince, e.g. 'jiangsu'. In this case, we map directly to China.
 * See sanitized.json for some other sanitazations, these are empirical, so
 * we add them as we discover them.
 */


function sanitizeCountry(input) {
  if (sanitized_json_1["default"][input.toLowerCase()]) {
    return sanitized_json_1["default"][input.toLowerCase()];
  }

  return input; // FIXME The above castings seems hacky, should we just use an external
  // service to get country from lat/lng?
}
/**
 * Normalize aqicn byGps data
 *
 * @param data - The data to normalize
 */


function normalize(data) {
  var stationId = "aqicn|" + data.idx; // Sometimes we don't get geo

  if (!data.city.geo) {
    return E.left(util_1.providerError('aqicn', "Cannot normalize station " + stationId + ", no city: " + JSON.stringify(data)));
  } // Since AqiCN uses useEpa as AQI for the pollutants, we can only
  // normalize data for those pollutants


  var pollutants = Object.entries(data.iaqi || {}).filter(function (_a) {
    var _b = __read(_a, 1),
        pol = _b[0];

    return convert_1.usaEpa.pollutants.includes(pol);
  });

  if (!pollutants.length) {
    return E.left(util_1.providerError('aqicn', "Cannot normalize station " + stationId + ", no pollutants currently tracked: " + JSON.stringify(data)));
  } // We now need to get the country from AQICN response. The only place I found
  // is city.url...
  // Example: https://aqicn.org/city/france/lorraine/thionville-nord/garche/


  var AQICN_DOMAIN = 'aqicn.org/city/';

  if (!data.city.url || !data.city.url.includes(AQICN_DOMAIN)) {
    return E.left(util_1.providerError('aqicn', "Cannot extract country, got city.url: " + data.city.url));
  }

  var countryRaw = sanitizeCountry(data.city.url.split(AQICN_DOMAIN)[1].split('/')[0]); // Get the timezoned date

  var utc = new Date(+data.time.v * 1000).toISOString();
  var local = date_fns_tz_1.format(date_fns_tz_1.utcToZonedTime(+data.time.v * 1000, data.time.tz || 'Z'), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
  return pipeable_1.pipe(util_1.getCountryCode(countryRaw), E.fromOption(function () {
    return util_1.providerError('aqicn', "Cannot get code from country " + countryRaw);
  }), E.map(function (country) {
    return pollutants.map(function (_a) {
      var _b = __read(_a, 2),
          pol = _b[0],
          v = _b[1].v;

      var pollutant = pol;

      if (!data.city.geo) {
        throw new Error('We returned TE.left if data.city.geo was not defined. qed.');
      }

      return {
        attribution: data.attributions,
        averagingPeriod: {
          unit: 'day',
          value: 1
        },
        city: data.city.name || 'Unknown city',
        coordinates: {
          latitude: +data.city.geo[0],
          longitude: +data.city.geo[1]
        },
        country: country,
        date: {
          local: local,
          utc: utc
        },
        location: stationId,
        mobile: false,
        parameter: pollutant,
        sourceName: 'aqicn',
        sourceType: 'other',
        value: convert_1.convert(pollutant, 'usaEpa', 'raw', v),
        unit: convert_1.getPollutantMeta(pollutant).preferredUnit
      };
    });
  }));
}

exports.normalize = normalize;